module.exports = __webpack_public_path__ + "assets/images/animations/fundivisa-animation.png?f441dd37";